var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBobsleigh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.167 42.688c.616 2.322 1.858 4.39 3.533 6.015l-1.073-.153c-1.712-.241-2.92-1.8-2.725-3.516l.265-2.346Zm25.242.144.24 2.224c.186 1.707-1.015 3.254-2.717 3.5l-1.018.147c1.515-1.468 2.675-3.3 3.339-5.353l.156-.518Zm-1.891-37.953 0 1.783-.03-.001 0 10.779-.27.132.3-12.693Zm-21.384 0 .299 12.693-.31-.15 0-12.546.01.003Zm23.778-.582c3.548-.705 4.07.16 3.586 2.412l-.428 1.637c-.834 3.103-1.533 5.18-2.096 6.234-.246.46-.61.902-1.09 1.327l-.003-6.77.03.003.001-4.843Zm-26.182-.002-.002 11.577c-.461-.414-.811-.845-1.05-1.292-.658-1.229-1.499-3.852-2.525-7.871-.483-2.25.038-3.115 3.577-2.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB4D4E",
    d: "m27.518.995 0 5.667-.03-.001.002 32.67c0 5.893-4.783 10.669-10.683 10.669-5.9 0-10.682-4.776-10.682-10.668l0-38.337c0-1.327 3.171-1.327 3.445 0l.693 3.882 13.116 0 .693-3.882c.274-1.327 3.446-1.327 3.446 0Zm-6.336 8.754-8.75 0c-1.762 0-3.191 1.427-3.191 3.188l0 15.053c0 4.174 3.387 7.557 7.566 7.557 4.18 0 7.567-3.383 7.567-7.557l0-15.053c0-1.76-1.43-3.188-3.192-3.188Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.125 31.507c-.834 10.133 2.727 15.2 10.682 15.2 7.956 0 11.517-5.067 10.683-15.2l0 7.81c0 5.9-4.783 10.683-10.683 10.683-5.9 0-10.682-4.783-10.682-10.682l0-7.811 0 0Z",
    opacity: 0.326
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B43C3D",
    points: "10.267 4.879 11.523 4.879 11.108 8.083"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B43C3D",
    points: "22.114 4.879 23.37 4.879 22.955 8.083",
    transform: "matrix(-1 0 0 1 45.484 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.683,
    cy: 28.058,
    fill: "#FFF",
    rx: 5.286,
    ry: 4.757
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.953,
    cy: 16.509,
    fill: "#FFF",
    rx: 5.286,
    ry: 4.757
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobsleigh);
export default __webpack_public_path__ + "static/media/bobsleigh.b394e30cbc841b26dc98ef7b1977e60a.svg";
export { ForwardRef as ReactComponent };